import React, { useState, useEffect } from "react";
import { Card, CardImg, CardBody, CardText, Badge, Spinner } from "reactstrap";
import "assets/scss/website/app.scss";
import compoundImg from "assets/images/bg.png";
import whatsapp from "assets/images/whatsapp.png";
import { addInterestUnit } from "store/Auth/actions";
import { useSelector, useDispatch } from "react-redux";
import developerdImg from "assets/images/developer_logo.png";
import { useTranslation } from "react-i18next";
import ReactWhatsapp from "react-whatsapp";
import CallModal from "./Modal/CallModal";
import MessageModal from "./Modal/MessageModal";

const UnitCard = ({ item, index, history, profile, updateProfileInterest }) => {
	const { t } = useTranslation();
	const [Interested, setInterested] = useState(false);
	const [toggleInterest, setToggleInterest] = useState(false);
	const [callModal, setCallModal] = useState(false);
	const [messageModal, setMessageModal] = useState(false);

	const AuthData = useSelector((state) => state.Auth);
	const currency = useSelector((state) => state.Auth?.currency);
	const dispatch = useDispatch();

	useEffect(() => {
		const id = parseInt(item?.id);
		setInterested(AuthData.interestsUnits.includes(id));
	}, [AuthData.interestsUnits]);

	const isInterested = () => {
		const id = parseInt(item?.id);
		return AuthData.interestsUnits.includes(id);
	};

	const interestHandler = (id) => {
		setToggleInterest(true);
		const data = {
			unit_id: id,
		};
		if (!isInterested()) {
			dispatch(addInterestUnit(id, data, "add", setToggleInterest));
			//   setToggleInterest(false)
		} else {
			dispatch(
				addInterestUnit(
					id,
					data,
					"delete",
					setToggleInterest,
					updateProfileInterest,
					profile
				)
			);
			// setToggleInterest(false)

			// if (profile) {
			//     updateProfileInterest()
			// }
		}
	};

	return (
		<div
			className="websitPages"
			key={index}
			onClick={() => history.push(`/property-details/${item?.id}`)}>
			<div>
				<Card className="comCard me-2 position-relative">
					<div className="heart-match">
						{toggleInterest ? (
							<div className="w-100 d-flex justify-content-center pt-2">
								<Spinner size="sm" color="primary" />
							</div>
						) : (
							<div
								onClick={(e) => {
									e.stopPropagation();
									interestHandler(item?.id);
								}}>
								<button className="btn text-center">
									{Interested ? (
										<i className="fas fa-heart text-danger"></i>
									) : (
										<i className="far fa-heart text-danger"></i>
									)}
								</button>
							</div>
						)}
					</div>
					{item?.images?.length > 0 ? (
						<CardImg src={item?.images?.[0].path} />
					) : (
						<CardImg src={compoundImg}></CardImg>
					)}
					{item?.developer?.media?.path ? (
						<img src={item.developer.media.path} className="imgAbsolute" />
					) : (
						<img src={developerdImg} className="imgAbsolute" />
					)}
					<CardBody className="position-relative">
						<div className="d-flex gap-2 mb-2 justify-content-between align-items-center">
							<CardText
								tag="h4"
								className="text-color fw-bold mb-0 font-size-18">
								{item?.name[`${AuthData.lang}`]
									? item?.name[`${AuthData.lang}`]
									: item?.name?.en}
							</CardText>
							<span className="text-color font-size-12">
								{item?.unit_type?.name[`${AuthData.lang}`]
									? item?.unit_type?.name[`${AuthData.lang}`]
									: item?.unit_type?.name?.en}
							</span>
						</div>
						{(!!item?.city?.name?.en ||
							!!item?.area?.name?.en ||
							!!item?.address?.en) && (
							<p className="w-100 text-color address-compound mb-2">
								{item?.address[`${AuthData?.lang}`]
									? item?.address[`${AuthData?.lang}`]
									: item?.address?.en}
								,
								{item?.area?.name[`${AuthData?.lang}`]
									? item?.area?.name[`${AuthData?.lang}`]
									: item?.area?.name?.en}
								,
								{item?.city?.name[`${AuthData?.lang}`]
									? item?.city?.name[`${AuthData?.lang}`]
									: item?.city?.name?.en}
							</p>
						)}

						<div className="maxBodyHeightNew">
							<div className="d-flex pt-2 justify-content-between">
								{(!!item?.bedrooms || !!item?.bathrooms) && (
									<div>
										{!!item?.bedrooms && (
											<div>
												<span className="text-color font-size-12">
													{t("Bedrooms")}
												</span>
												<p className="w-100 font-size-16 text-color my-0">
													{item?.bedrooms} {t("rooms")}
												</p>
											</div>
										)}
										{!!item?.bathrooms && (
											<div>
												<span className="text-color font-size-12">
													{t("Bathrooms")}
												</span>
												<p className="w-100 font-size-16 text-color my-0">
													{item?.bathrooms} {t("rooms")}
												</p>
											</div>
										)}
									</div>
								)}
								{!!item?.size && (
									<div>
										{!!item?.size && (
											<div>
												<span className="text-color font-size-12">
													{t("sqm")}
												</span>
												<p className="w-100 font-size-16 text-color my-0">
													{parseInt(item?.size).toFixed(0)}
												</p>
											</div>
										)}
									</div>
								)}
							</div>
							{/* {!!item?.floor && (
								<p className="w-100 text-black mb-2">
									<i className="fas me-1 fa-door-open"> </i> {item?.floor}{" "}
									{t("Floor No.")}
								</p>
							)} */}
							<hr />
						</div>
						<p className="mb-0 font-size-12 text-color">{t("deposte")}</p>
						<p className="mb-0 font-size-14 text-color mb-2">
							{toCurrency(item?.deposit)} {currency?.currency_code}
						</p>
						<CardText tag="h4" className="mb-2">
							<span className="font-size-18 text-color fw-bold">
								{toCurrency(item?.price)} {currency?.currency_code}
							</span>
							{/* <Badge className="bg-primary p-2  font-size-12 ">
									{item?.finishing_type?.name[`${AuthData.lang}`]
										? item?.finishing_type?.name[`${AuthData.lang}`]
										: item?.finishing_type?.name.en}
								</Badge> */}
						</CardText>
						<p className="more-iformation mt-3">{t("More Information")}</p>
						{/* <div className="d-flex interset-style">
							<div className="w-100">
								<button
									className="w-100 btn btnCall text-center"
									onClick={(e) => {
										e.stopPropagation();
										setCallModal(true);
									}}>
									<i className="fas fa-phone-alt me-1"></i>
									{t("call")}
								</button>
							</div>
							<div className="mx-2 w-100">
								<button
									className="w-100 btn btnMessage text-center"
									onClick={(e) => {
										e.stopPropagation();
										setMessageModal(true);
									}}>
									<i className="fa fa-envelope"></i>
								</button>
							</div>

							<div className="mx-2 w-100">
								<ReactWhatsapp
									number={
										item?.sales_rep?.phone?.includes("+")
											? item?.sales_rep?.phone
											: `+2${item?.sales_rep?.phone}`
									}
									class="btn btnMessage w-100"
									message="">
									<img src={whatsapp} alt="whatsapp" width="20" />
								</ReactWhatsapp>
							</div>
						</div> */}
					</CardBody>
				</Card>
			</div>
			{callModal && (
				<CallModal
					modal={callModal}
					setModal={setCallModal}
					phone={item?.sales_rep?.phone}
				/>
			)}
			{messageModal && (
				<MessageModal
					modal={messageModal}
					setModal={setMessageModal}
					item={item}
					type="unit"
				/>
			)}
		</div>
	);
};

const toCurrency = (number) => {
	const formatter = new Intl.NumberFormat("en-US");
	return formatter.format(number);
};
export default UnitCard;
